import kamala from '../../kamala'
import Menu from './Menu'
import SubMenu from './SubMenu'
import MenuItem from './MenuItem'
import MenuItemGroup from './MenuItemGroup'

const KMenuFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Menu.name, Menu)
    Vue.component(SubMenu.name, SubMenu)
    Vue.component(MenuItem.name, MenuItem)
    Vue.component(MenuItemGroup.name, MenuItemGroup)
  },
  KMenu: Menu,
  KSubmenu: SubMenu,
  KMenuItem: MenuItem,
  KMenuItemGroup: MenuItemGroup,
}

export {
  Menu,
  SubMenu,
  MenuItem,
  MenuItemGroup,
}

export default KMenuFamily
